import { AppCore } from "../AppCore";
/**
 * AbstractHandler.ts
 */
export class AbstractHandler {
    constructor() {
        this.initialise();
        this.createModel();
        this.create();
    }
    initialise() {
        this.core = AppCore.getInstance();
    }
    createModel() {
    }
    create() {
    }
    destroy() {
        this.sleep();
    }
    addEventListeners() {
    }
    removeEventListeners() {
    }
    listen(type, handler, scope) {
        this.core.addEventListener(type, handler, scope);
    }
    remove(type, scope) {
        this.core.removeEventListener(type, scope);
    }
    dispatchEvent(event) {
        this.core.dispatchEvent(event);
    }
    async dispatchBlockingEvent(event) {
        await this.core.dispatchBlockingEvent(event);
    }
    run() {
        if (!this.isRunning) {
            this.isRunning = true;
            this.addEventListeners();
        }
    }
    sleep() {
        if (this.isRunning) {
            this.isRunning = false;
            this.removeEventListeners();
        }
    }
}
//# sourceMappingURL=AbstractHandler.js.map